import { createSimpleStore } from 'react-simple-reducer'
import { Usuario, TIPO_USUARIO_PLURAL } from '../pages/UsuariosCurso/Usuario'
import api, { IQueryParams, ICounter } from '../api'

export interface IRequest {
  errorCode: number
  message: string
  fetching: boolean
}

export interface IUsuariosState {
  store: {
    [key: string]: {
      usuarios: Usuario[]
      usuariosCount: number
      request: IRequest
      query: IQueryParams
    }
  }
}

const storeInitialState = {
  usuarios: [],
  usuariosCount: 0,
  request: {
    fetching: false,
    errorCode: null,
    message: '',
  },
  query: { limit: 10, offset: 0 },
}

export const initialState: IUsuariosState = {
  store: {},
}

const usuariosStore = createSimpleStore(
  initialState,
  {
    initStore(state, payload: { target: string }) {
      state.store[payload.target] = { ...storeInitialState }
    },
    requestAsync(state, payload: { target: string }) {
      if (!state.store[payload.target]) state.store[payload.target] = { ...storeInitialState }
      state.store[payload.target].request = { ...storeInitialState.request, fetching: true }
    },
    requestClean(state, payload: { target: string }) {
      state.store[payload.target].request = storeInitialState.request
    },
    requestError(state, payload: { target: string; errorCode: number; message: string }) {
      state.store[payload.target].request = {
        errorCode: payload.errorCode,
        message: payload.message,
        fetching: false,
      }
    },
    usuariosGetSuccess(state, payload: { target: string; rows: Usuario[]; count: number }) {
      state.store[payload.target].usuarios = payload.rows
      state.store[payload.target].usuariosCount = payload.count
      state.store[payload.target].request = storeInitialState.request
    },
    usuariosCreateOrUpdateSuccess(state, payload: Usuario & { target: string }) {
      state.store[payload.target].usuarios = state.store[payload.target].usuarios.filter(
        (c) => payload.id !== c.id
      )
      state.store[payload.target].usuarios.push(payload)
    },
    usuariosDeleteSuccess(state, payload: { target: string; id: number }) {
      state.store[payload.target].usuarios = state.store[payload.target].usuarios.filter(
        (c) => +c.id !== payload.id
      )
    },
    setQueryParams(state, payload: { target: string } & IQueryParams) {
      state.store[payload.target].query = { ...state.store[payload.target].query, ...payload }
    },
  },
  {
    thunks: {
      createOrUpdateUsuariosCursos: (values: Partial<Usuario>, target: string) => async (dispatch) => {
        try {
          const usuarios = await api.UsuariosCursos.post(values)
          // API returns array but we expect single usuario
          const usuario = usuarios[0]
          dispatch(usuariosStore.actions.usuariosCreateOrUpdateSuccess({ ...usuario, target }))
        } catch (e) {
          dispatch(usuariosStore.actions.requestError({
              target,
              errorCode: 400,
              message: 'Falha ao salvar o usuario',
            }))
        }
      },
    },
  }
)

export const { Provider: UsuariosProvider, useDispatch: useUsuariosDispatch, useState: useUsuariosState, useSelector: useUsuariosSelector } = usuariosStore